export default __webpack_public_path__ + "static/media/D.C Bag.f3cd8927.jpg";